import { FC, useEffect, useState } from 'react';

import { getPurpurIcon } from '@telialt/common-icon/src/utils';
import { NavigationItem } from '@telialt/models/src/Navigation';
import { TeliaSegment, useSegment } from '@telialt/utils/src/segment';
import { useUserDataQueryBase } from '@telialt/utils/src/SSO/useUserData';
import { getIsUserAuthorized } from '@telialt/utils/src/SSO/utils';

import { NAVIGATION_TEST_IDS } from '../../test-ids';
import { MenuItemIcon } from '../MenuItem/MenuItem.styles';
import { MessagesCount, MessagesIconWrapper, MessagesLink } from './MenuItemMessages.styles';

interface Props {
    item: NavigationItem;
}

export const MenuItemMessages: FC<Props> = ({ item }) => {
    const [isMounted, setIsMounted] = useState(false);
    const [isAuthorized, setIsAuthorized] = useState(false);
    const segment = useSegment();
    const { userData } = useUserDataQueryBase({
        isEnabled: isMounted,
    });

    useEffect(() => {
        setIsMounted(true);
        setIsAuthorized(getIsUserAuthorized());
    }, []);

    if (segment !== TeliaSegment.B2c || !isAuthorized) {
        return null;
    }

    const { messagesFresh } = userData || {};
    const { title, displayOption, url, icon } = item;
    const purpurIcon = getPurpurIcon(icon);

    return (
        <MessagesLink $displayOption={displayOption} href={url} data-test={NAVIGATION_TEST_IDS.MESSAGES}>
            <MessagesIconWrapper>
                {!!messagesFresh && (
                    <MessagesCount data-test={NAVIGATION_TEST_IDS.MESSAGES_COUNT}>
                        {messagesFresh > 9 ? '...' : messagesFresh}
                    </MessagesCount>
                )}
                {purpurIcon && <MenuItemIcon svg={purpurIcon} size="sm" />}
            </MessagesIconWrapper>
            {title}
        </MessagesLink>
    );
};
